'use strict';

/** Updates unit Beans using the server calculation for the selected purchase option. */
function updateBeans($container) {
	const $beans = $container.find('.beans-worth');
	const $options = $container.find('.product-refill-options.lvz-pdp-refill').first();
	const isRecurring = $options.find('input[type=radio]:checked').val() === 'true';
	const recurringBeans = $beans.attr('data-recurring-beans');
	const value = isRecurring && recurringBeans != null && recurringBeans !== ''
		? recurringBeans
		: $beans.attr('data-one-time-beans');
	if (value == null) {
		return;
	}
	const beans = Number(value) || 0;
	$beans.toggleClass('d-none', !beans).find('.beans').text(beans);
}

function refreshBeans() {
	$('.product-detail').each(function () {
		updateBeans($(this));
	});
}

module.exports = {
	init: function () {
		$(document).off('change.lvzLoyaltyBeans', '.product-refill-options input[type=radio]');
		$(document).on('change.lvzLoyaltyBeans', '.product-refill-options input[type=radio]', function () {
			updateBeans($(this).closest('.product-detail'));
		});

		$('body').off('product:afterAttributeSelect.lvzLoyaltyBeans');
		$('body').on('product:afterAttributeSelect.lvzLoyaltyBeans', function (_event, response) {
			if (!response || !response.data || !response.data.product) {
				return;
			}
			const $container = response.container && response.container.length ? response.container : $('.product-detail');
			const product = response.data.product;
			const beans = product.oneTimeBeans;
			if (beans != null) {
				$container.find('.beans-worth').attr({
					'data-one-time-beans': beans,
					'data-recurring-beans': product.recurringBeans != null ? product.recurringBeans : ''
				});
				$container.each(function () {
					updateBeans($(this));
				});
			}
		});

		// The refill fragment is replaced asynchronously after variation changes.
		$(document).off('ajaxComplete.lvzLoyaltyBeans');
		$(document).on('ajaxComplete.lvzLoyaltyBeans', function (_event, _xhr, settings) {
			if (settings && settings.url && settings.url.indexOf('SmartOrderRefillController-PDPRefillOptions') !== -1) {
				refreshBeans();
			}
		});

		refreshBeans();
	}
};
